import React from 'react'
import {Icon} from '@chakra-ui/react'

const SupportIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M8 18.6663H12C12.7072 18.6663 13.3855 18.9472 13.8856 19.4473C14.3857 19.9474 14.6667 20.6257 14.6667 21.3329V25.3329C14.6667 26.0402 14.3857 26.7184 13.8856 27.2185C13.3855 27.7186 12.7072 27.9996 12 27.9996H10.6667C9.95942 27.9996 9.28115 27.7186 8.78105 27.2185C8.28095 26.7184 8 26.0402 8 25.3329V18.6663ZM8 18.6663C8 17.0904 8.31039 15.53 8.91345 14.0741C9.5165 12.6182 10.4004 11.2953 11.5147 10.181C12.629 9.06668 13.9519 8.18276 15.4078 7.57971C16.8637 6.97665 18.4241 6.66626 20 6.66626C21.5759 6.66626 23.1363 6.97665 24.5922 7.57971C26.0481 8.18276 27.371 9.06668 28.4853 10.181C29.5996 11.2953 30.4835 12.6182 31.0866 14.0741C31.6896 15.53 32 17.0904 32 18.6663M32 18.6663V25.3329C32 26.0402 31.719 26.7184 31.219 27.2185C30.7189 27.7186 30.0406 27.9996 29.3333 27.9996H28C27.2928 27.9996 26.6145 27.7186 26.1144 27.2185C25.6143 26.7184 25.3333 26.0402 25.3333 25.3329V21.3329C25.3333 20.6257 25.6143 19.9474 26.1144 19.4473C26.6145 18.9472 27.2928 18.6663 28 18.6663H32Z"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32 25.333V27.9997C32 29.4142 31.4381 30.7707 30.4379 31.7709C29.4377 32.7711 28.0812 33.333 26.6667 33.333H20"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default SupportIcon
